import { createRoot, _roots } from "@react-three/fiber";
import { useState, useRef, useEffect } from "react";
import { createEvents } from "./main14.mjs";
import { useFunction } from "./main13.mjs";
function useOnAdd(fromLngLat, { frameloop, ...renderProps }) {
  const [mounted, setMounted] = useState(false);
  const r3mRef = useRef({ fromLngLat });
  const onAdd = useFunction((map, gl) => {
    const canvas = map.getCanvas();
    const root = createRoot(canvas);
    root.configure({
      dpr: window.devicePixelRatio,
      events: createEvents(),
      ...renderProps,
      frameloop: "never",
      gl: {
        context: gl,
        depth: true,
        autoClear: false,
        antialias: true,
        ...renderProps == null ? void 0 : renderProps.gl
      },
      onCreated: (state) => {
        state.gl.forceContextLoss = () => {
        };
      },
      camera: {
        matrixAutoUpdate: false,
        near: 0
      },
      size: {
        width: canvas.clientWidth,
        height: canvas.clientHeight,
        top: 0,
        left: 0,
        updateStyle: false,
        ...renderProps == null ? void 0 : renderProps.size
      }
    });
    const store = _roots.get(canvas).store;
    r3mRef.current.map = map;
    r3mRef.current.root = root;
    r3mRef.current.state = store.getState();
    store.setState({ r3m: r3mRef.current });
    if (frameloop === "demand") {
      store.setState({
        frameloop,
        invalidate: () => {
          map.triggerRepaint();
        }
      });
    }
    map.on("resize", onResize);
    setTimeout(() => setMounted(true));
  });
  const onResize = useFunction(() => {
    if (!r3mRef.current.map)
      return;
    if (!r3mRef.current.state)
      return;
    const map = r3mRef.current.map;
    const canvas = map.getCanvas();
    let updateDPR = canvas.classList.contains("mapboxgl-canvas");
    if (!updateDPR && map.getPixelRatio && map.getPixelRatio() === window.devicePixelRatio) {
      updateDPR = true;
    }
    if (updateDPR) {
      r3mRef.current.state.setDpr(window.devicePixelRatio);
    }
    r3mRef.current.state.setSize(
      canvas.clientWidth,
      canvas.clientHeight,
      false
    );
  });
  const onRemove = useFunction(() => {
    if (!r3mRef.current.root)
      return;
    r3mRef.current.root.unmount();
    r3mRef.current.root = void 0;
    if (!r3mRef.current.map)
      return;
    r3mRef.current.map.off("resize", onResize);
  });
  useEffect(() => () => onRemove(), [onRemove]);
  return { onAdd, onRemove, mounted, r3mRef };
}
export {
  useOnAdd
};
//# sourceMappingURL=main12.mjs.map
